import React from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import EditText from '../../component/EditText';
import SelectBox from '../../component/SelectBox';
import SelectDate from '../../component/SelectDate';
import img_main from '../../assets/images/img_main_01.png';

import PageBar from '../../component/PageBar';
import { Get, Update, Create, Delete } from './http';
import { GetList as GetListBranch } from '../branch/http';
import { GetList as GetListManager } from '../manager/http';
import { GetList as GetListDriver } from '../driver/http';
import { GetList as GetListPlaceManager } from '../placemanager/http';
import moment from 'moment';
import HookRoute from '../../HookRoute';
import AutoComplete from '../../component/AutoComplete';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                type: 2,
                recptn_cnt: 0,
                recptn_no: 0,
                bal_engr_nm: '',
                inspct_odr: '',
                buld_nm: '',
                bal_car_alct_seq: 0,
                ispt_chk_sign_url: '',
                pos_cpny_cd: '',
                ledg_mnfctur_company_nm: '',
                pos_chk: '',
                ledg_mnfctur_hedofc_telno: '',
                ledg_live_load: 0,
                ledg_mnt_cpny_info: '',
                virtl_team: 0,
                inspct_instt_cd: '',
                recptn_de: '',
                rn: 0,
                reqst_mnfctur_cpny_info: '',
                cstmr_guidance_no: '',
                ledg_mnfctur_cpny_info: '',
                main_inspctr_nm: '',
                main_inspctr_exc: '',
                ledg_elvtr_div: '',
                inspct_dt: '',
                address: '',
                reqst_live_load: 0,
                partcpnt_telno_2: '',
                bal_engr_mobile_no: '',
                agency_instt_cd: '',
                ispt_chk_n_cnt: 0,
                sido: '',
                inspct_kind_nm: '',
                reqst_elvtr_div: '',
                reqst_mnfctur_company_nm: '',
                inspct_instt_nm: '',
                reqst_de: '',
                solo_gubun: '',
                post_address: '',
                reqst_mnfctur_company_telno: '',
                ledg_mnt_company_nm: '',
                sigungu: '',
                ledg_elvtr_form: '',
                ispt_chk_yn_txt: '',
                partcpnt_telno_1: '',
                ledg_mnt_hedofc_telno: '',
                bal_engr_seq: 0,
                rnum: 0,
                main_inspctr_tel: '',
                reqst_elvtr_form: '',
                bal_car_no: '',
                asign_de: '',
                ispt_chk_yn: '',
                reqst_id: '',
                bal_engr_exc: '',
                reqst_nm: '',
                elevatorId: '',
                branchId: 0,
                driverId: 0,
                manager1Id: 0,
                manager2Id: 0,
                manager3Id: 0,
                placemanager1Id: 0,
                pay: 'N',
                fm: 'N',
                status: 'OPENED',
            },
            YN: [
                { idx: 'Y', title: 'Y' },
                { idx: 'N', title: 'N' },
            ],
            inspct_kind: [
                { idx: '', title: '' },
                { idx: '설치', title: '설치' },
                { idx: '수시', title: '수시' },
                { idx: '정밀', title: '정밀' },
                { idx: '설치(수시)', title: '설치(수시)' },
                { idx: '설치(완성)', title: '설치(완성)' },
                { idx: '진단(인증)', title: '진단(인증)' },
                { idx: '자체하중', title: '자체하중' },
                { idx: '정밀/설치/진단', title: '정밀/설치/진단' },
                { idx: '일반작업용리프트', title: '일반작업용리프트' },
                { idx: '건설작업호이스트', title: '건설작업호이스트' },
                { idx: '천정크레인', title: '천정크레인' },
                { idx: '분동임대', title: '분동임대' },
            ],
            number: [
                { idx: 0, title: '0' },
                { idx: 1, title: '1' },
                { idx: 2, title: '2' },
                { idx: 3, title: '3' },
                { idx: 4, title: '4' },
                { idx: 5, title: '5' },
                { idx: 6, title: '6' },
                { idx: 7, title: '7' },
                { idx: 8, title: '8' },
                { idx: 9, title: '9' },
                { idx: 10, title: '10' },
            ],
            branch: [],
            driver: [],
            manager: [],
            placemanager: [],
        };

        GetListBranch(this, { size: 10000, role: 'BRANCH', status: 'OPENED', sort: 'title' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.title };
            });
            rows.unshift({ idx: null, title: '' });

            this.setState({
                branch: rows,
            });
        });

        GetListManager(this, { size: 10000, status: 'OPENED', sort: 'name' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.name };
            });
            rows.unshift({ idx: null, title: '' });

            this.setState({
                manager: rows,
            });
        });

        GetListPlaceManager(this, { size: 10000, status: 'OPENED', sort: 'name' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.name };
            });
            rows.unshift({ idx: null, title: '' });

            this.setState({
                placemanager: rows,
            });
        });
        this.reloadDriver();
    }

    reloadDriver = () => {
        const params = { size: 10000, status: 'OPENED', sort: 'name' };
        if (this.state.data.branchId) {
            params.branchId = this.state.data.branchId;
        }

        GetListDriver(this, params, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.name };
            });
            rows.unshift({ idx: null, title: '' });

            this.setState({
                driver: rows,
            });
        });
    };

    /**
     * 등록
     * @param {*} e
     */
    clickAdd = e => {
        const { data } = this.state;

        if (!data.receiptAt) {
            data.receiptAt = moment().format('YYYY-MM-DD');
        } else {
            data.receiptAt = moment(data.receiptAt).format('YYYY-MM-DD HH:mm:ss');
        }
        // if (!data.elevatorId) {
        //     data.elevatorId = '';
        // }

        if (!data.driverId) {
            data.driverId = 0;
        }
        if (!data.manager1Id) {
            data.manager1Id = 0;
        }
        if (!data.manager2Id) {
            data.manager2Id = 0;
        }
        if (!data.manager3Id) {
            data.manager3Id = 0;
        }
        if (!data.placemanager1Id) {
            data.placemanager1Id = 0;
        }
        data.inspct_dt = moment(data.inspct_dt).format('YYYY-MM-DD HH:mm:ss');

        if (this.id) {
            Update(this, this.id, data, res => {
                alert('저장이 완료 되었습니다.');
                window.location = '/a/batcha/list';
            });
        } else {
            delete data.id;
            Create(this, data, res => {
                alert('저장이 완료 되었습니다.');
                window.location = '/a/batcha/list';
            });
        }
    };

    /**
     * 배차 복사
     */
    clickCopy = e => {
        this.id = undefined;
        this.state.data.driverId = 0;
        this.setState({ ...this.state.data });
    };

    /**
     * 삭제
     * @param {*} item
     */
    clickDelete = e => {
        var result = window.confirm('삭제 하시겠습니까?');
        if (result) {
            Delete(this, this.id, res => {
                alert('삭제가 완료 되었습니다.');
                window.location = '/a/batcha/list';
            });
        }
    };

    /**
     *
     * @param {*} array
     * @param {*} value
     */
    selector = (array, key, value) => {
        const { data } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    data[key] = e.target.value;
                    this.setState({ data }, () => {
                        if (key === 'branchId') {
                            this.reloadDriver();
                        }
                    });
                }}
                value={value}
            >
                {array.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    selector2 = (array, key, value) => {
        const { data } = this.state;

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {/* <Form.Control
                    as="select"
                    onChange={e => {
                        data[key] = e.target.value;
                        this.setState({ data }, () => {
                            if (key === 'branchId') {
                                this.reloadDriver();
                            }
                        });
                    }}
                    value={value}
                >
                    {array.map(x => (
                        <option value={x.idx}>{x.title}</option>
                    ))}
                </Form.Control> */}

                <AutoComplete
                    onChange={val => {
                        data[key] = val.idx;
                        this.setState({ data }, () => {
                            if (key === 'branchId') {
                                this.reloadDriver();
                            }
                        });
                    }}
                    value={value}
                    suggestions={array}
                />
            </div>
        );
    };

    render() {
        const { data } = this.state;
        return (
            <HookRoute
                load={params => {
                    const { id } = params;
                    this.id = id;
                    if (this.id) {
                        Get(this, this.id, res => {
                            this.setState({ data: res }, () => {
                                this.reloadDriver();
                            });
                        });
                    }
                }}
            >
                <Row>
                    <Col>
                        <div className="board_top_box green">
                            <div className="lb"></div>

                            <div className="rb"></div>
                        </div>

                        <Card>
                            <Card.Header style={{ backgroundColor: '#66b1a6' }}>
                                <Card.Title as="h5">배차정보 {this.id ? '수정' : '등록'}</Card.Title>
                                <div className="rb">
                                    {/* <button type="button" className="btn_02">
                                        법인사업자 견적서출력
                                    </button>
                                    <button type="button" className="btn_02">
                                        일반사업자 견적서출력
                                    </button> */}
                                    {this.id && (
                                        <button type="button" className="btn_02 blue" onClick={this.clickCopy}>
                                            배차복사
                                        </button>
                                    )}
                                    {this.id && (
                                        <button type="button" className="btn_02 red" onClick={this.clickDelete}>
                                            배차삭제
                                        </button>
                                    )}
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board small">
                                        <thead>
                                            <tr>
                                                <th>지역사무소</th>
                                                <th>검사예정날짜</th>
                                                <th>검사예정시간</th>
                                                <th>건물명</th>
                                                <th>건물주소</th>
                                                <th>접수일자</th>
                                                <th>고객안내번호</th>
                                                <th>검사종류</th>
                                                <th>검사대수</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{this.selector(this.state.branch, 'branchId', data.branchId)}</td>
                                                <td>
                                                    <Form.Control
                                                        type={'date'}
                                                        value={moment(data.inspct_dt).format('YYYY-MM-DD')}
                                                        style={{ width: 100 }}
                                                        onChange={e => {
                                                            if (data.inspct_dt) {
                                                                data.inspct_dt =
                                                                    moment(e.target.value).format('YYYY-MM-DD') +
                                                                    ' ' +
                                                                    moment(data.inspct_dt).format('HH:mm:ss');
                                                            } else {
                                                                data.inspct_dt = moment(e.target.value).format('YYYY-MM-DD') + ' 00:00';
                                                            }
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'time'}
                                                        timeformat="12h"
                                                        value={moment(data.inspct_dt).format('HH:mm')}
                                                        style={{ width: 100 }}
                                                        onChange={e => {
                                                            if (data.inspct_dt) {
                                                                data.inspct_dt = moment(data.inspct_dt).format('YYYY-MM-DD') + ' ' + e.target.value + ':00';
                                                                this.setState({ data });
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.buld_nm}
                                                        onChange={e => {
                                                            data.buld_nm = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.address}
                                                        onChange={e => {
                                                            data.address = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'date'}
                                                        value={moment(data.receiptAt).format('YYYY-MM-DD')}
                                                        style={{ width: 100 }}
                                                        onChange={e => {
                                                            data.receiptAt = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.cstmr_guidance_no}
                                                        onChange={e => {
                                                            data.cstmr_guidance_no = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>{this.selector(this.state.inspct_kind, 'inspct_kind_nm', data.inspct_kind_nm)}</td>
                                                <td>{this.selector(this.state.number, 'recptn_cnt', data.recptn_cnt)}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="gab40"></div>

                                    <table className="tbl_board small">
                                        <thead>
                                            <tr>
                                                <th>검사신청자ID</th>
                                                <th>
                                                    승강기형식
                                                    <br />
                                                    (원장기준)
                                                </th>
                                                <th>
                                                    최대시험하중
                                                    <br />
                                                    (원장기준)
                                                </th>
                                                <th>
                                                    대표제조업체명
                                                    <br />
                                                    (신청서기준)
                                                </th>
                                                <th>대표유지 관리업체</th>
                                                <th>
                                                    최대시험하중 <br />
                                                    (신청서기준)
                                                </th>
                                                <th>검사자1</th>
                                                <th>검사자2</th>
                                                <th>검사자3</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.reqst_id}
                                                        onChange={e => {
                                                            data.reqst_id = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.ledg_elvtr_form}
                                                        onChange={e => {
                                                            data.ledg_elvtr_form = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.ledg_live_load}
                                                        style={{ width: 100 }}
                                                        onChange={e => {
                                                            data.ledg_live_load = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.reqst_mnfctur_cpny_info}
                                                        onChange={e => {
                                                            data.reqst_mnfctur_cpny_info = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.ledg_mnt_cpny_info}
                                                        onChange={e => {
                                                            data.ledg_mnt_cpny_info = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'number'}
                                                        value={data.reqst_live_load}
                                                        style={{ width: 100 }}
                                                        onChange={e => {
                                                            data.reqst_live_load = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    {this.selector(this.state.manager, 'manager1Id', data.manager1Id)}
                                                    {/* {data.main_inspctr_nm} */}
                                                </td>
                                                <td>{this.selector(this.state.manager, 'manager2Id', data.manager2Id)}</td>
                                                <td>{this.selector(this.state.manager, 'manager3Id', data.manager3Id)}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="gab40"></div>

                                    <table className="tbl_board small">
                                        <thead>
                                            <tr>
                                                <th>분동기사</th>
                                                <th>현장담당자</th>
                                                <th>승강기고유번호</th>
                                                <th>FM여부</th>
                                                <th>결제</th>
                                                <th>수신자 FAX</th>
                                                <th>수신자 핸드폰</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {this.selector2(this.state.driver, 'driverId', data.driverId)}
                                                    {/* {data.bal_engr_nm} */}
                                                </td>
                                                <td>{this.selector2(this.state.placemanager, 'placemanager1Id', data.placemanager1Id)}</td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.elevatorId}
                                                        onChange={e => {
                                                            data.elevatorId = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>{this.selector(this.state.YN, 'fm', data.fm)}</td>
                                                <td>{this.selector(this.state.YN, 'pay', data.pay)}</td>

                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.fax}
                                                        onChange={e => {
                                                            data.fax = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={data.phone}
                                                        onChange={e => {
                                                            data.phone = e.target.value;
                                                            this.setState({ data });
                                                        }}
                                                    />
                                                </td>

                                                <td>
                                                    <Button variant="success" onClick={this.clickAdd}>
                                                        저장
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight"></div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </HookRoute>
        );
    }
}

export default List;
